import { useContext, useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { Modal, ModalBody } from "reactstrap";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import Tooltip from "../../../components/Tooltip/Tooltip";
import PaginationComponent from "../../../components/Pagination/Pagination";
import Button from "../../../components/Button/Button";
import Icon from "../../../components/Icon/Icon";
import EllipsisListItem from "../../../components/EllipsisListItem/EllipsisListItem";
import TableFilter from "../../../components/TableFilter/TableFilter";
import PageHeader from "../../../components/PageHeader/PageHeader";
import { Block } from "../../../components/Block/Block";
import {
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableItem,
  DataTableRow,
} from "../../../components/DataTable/DataTable";
import { areYouSureMessage } from "../../../utils/toastMessage/toastMessage";
import { notificationUserContext } from "../../../context/UserContext/NotificationUserContext/NotificationUserContext";
import { convertDate } from "../../../utils";

const NotificationsUser = () => {
  const [onSearch, setOnSearch] = useState(true);

  const {
    notifications,
    notification,
    setNotification,
    sort,
    setSort,
    filter,
    setFilter,
    pageCount,
    itemsCount,
    setItemsCount,
    pageNumber,
    setPageNumber,
    handleGetNotifications,
    handleReadNotification,
    handleReadAllNotification,
    handleDeleteNotification,
    handleDeleteAllNotification,
  } = useContext(notificationUserContext);

  useEffect(() => {
    handleGetNotifications();
  }, [pageNumber, itemsCount, sort]);

  return (
    <>
      <SiteTitle title="اعلان ها" />
      <PageHeader title="اعلان ها" />

      <TableFilter
        setItemsCount={setItemsCount}
        itemsCount={itemsCount}
        setSort={setSort}
        sort={sort}
      />

      <Block>
        <DataTable className="card-stretch">
          <div className="card-inner position-relative card-tools-toggle">
            <div className="card-title-group">
              <div className="card-tools mr-n1">
                <ul className="btn-toolbar gx-1">
                  {!isEmpty(notifications) && (
                    <>
                      <li>
                        <Button
                          color="danger"
                          className="btn-icon mr-1"
                          onClick={() =>
                            areYouSureMessage(
                              handleDeleteAllNotification,
                              `آیا از حذف همه اطلاعیه ها مطمئنید؟`
                            )
                          }
                        >
                          <Icon name="trash" />
                        </Button>
                      </li>
                      <li className="btn-toolbar-sep" />
                    </>
                  )}
                  {!isEmpty(notifications?.filter((_n) => !_n?.isRead)) && (
                    <>
                      <li>
                        <Button
                          color="primary"
                          className="btn-icon"
                          onClick={() =>
                            areYouSureMessage(
                              handleReadAllNotification,
                              `آیا از ویرایش اطلاعیه ها به خوانده شده مطمئنید؟`
                            )
                          }
                        >
                          <Icon name="eye" />
                        </Button>
                      </li>
                      <li className="btn-toolbar-sep" />
                    </>
                  )}
                  <li>
                    <button
                      onClick={() => setOnSearch(false)}
                      className="btn btn-icon search-toggle toggle-search"
                    >
                      <Icon name="search" />
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <div className={`card-search search-wrap ${!onSearch && "active"}`}>
              <div className="card-body">
                <form
                  onSubmit={handleGetNotifications}
                  className="search-content"
                >
                  <Button
                    className="search-back btn-icon toggle-search active"
                    onClick={() => {
                      setOnSearch(true);
                      setFilter("");
                    }}
                    type="button"
                  >
                    <Icon name="arrow-right" />
                  </Button>
                  <input
                    type="text"
                    className="border-transparent form-focus-none form-control"
                    placeholder="عنوان، توضیحات و ..."
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                  />
                  <Button type="submit" className="search-submit btn-icon">
                    <Icon name="search" />
                  </Button>
                </form>
              </div>
            </div>
          </div>

          <DataTableBody className="is-compact">
            <DataTableHead>
              <DataTableRow>
                <span className="sub-text">#</span>
              </DataTableRow>
              <DataTableRow>
                <span className="sub-text">عنوان</span>
              </DataTableRow>
              <DataTableRow size="mb">
                <span className="sub-text">تاریخ</span>
              </DataTableRow>
              <DataTableRow />
            </DataTableHead>
            {/*Head*/}
            {notifications.length > 0
              ? notifications.map((item, index) => {
                  return (
                    <DataTableItem
                      className={item.isRead ? "" : "bg-primary text-white"}
                      key={item._id}
                    >
                      <DataTableRow>
                        <span>{index + 1}</span>
                      </DataTableRow>
                      <DataTableRow>
                        <EllipsisListItem title={item.title} />
                      </DataTableRow>
                      <DataTableRow size="mb">
                        <span>
                          {convertDate(item.createdAt, "YYYY/MM/DD - HH:mm:ss")}
                        </span>
                      </DataTableRow>
                      <DataTableRow className="nk-tb-col-tools">
                        <ul className="nk-tb-actions gx-1">
                          <li
                            className={
                              item.isRead ? "" : "bg-primary text-white"
                            }
                            onClick={() => {
                              setNotification(item);
                              !item.isRead && handleReadNotification(item._id);
                            }}
                          >
                            <Tooltip
                              tag="a"
                              containerClassName="btn btn-trigger btn-icon"
                              id={"details" + item._id}
                              icon="eye"
                              direction="top"
                              text="جزئیات"
                            />
                          </li>
                          <li
                            className={
                              item.isRead ? "" : "bg-primary text-white"
                            }
                            onClick={() =>
                              areYouSureMessage(
                                () => handleDeleteNotification(item._id),
                                `آیا از حذف اطلاعیه ${item.title} مطمئنید؟`
                              )
                            }
                          >
                            <Tooltip
                              tag="a"
                              containerClassName="btn btn-trigger btn-icon text-danger"
                              id={"delete" + item._id}
                              icon="trash-fill"
                              direction="top"
                              text="حذف"
                            />
                          </li>
                        </ul>
                      </DataTableRow>
                    </DataTableItem>
                  );
                })
              : null}
          </DataTableBody>
          <div className="card-inner">
            {notifications.length > 0 ? (
              <PaginationComponent
                pageCount={pageCount}
                currentPage={pageNumber}
                setPageNumber={setPageNumber}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">داده ای برای نمایش یافت نشد</span>
              </div>
            )}
          </div>
        </DataTable>
      </Block>

      <Modal
        isOpen={!isEmpty(notification)}
        toggle={() => setNotification({})}
        className="modal-dialog-centered"
        size="md"
      >
        <ModalBody>
          <span
            type="button"
            onClick={() => setNotification({})}
            className="close"
          >
            <Icon name="cross-sm" />
          </span>
          <div className="p-2">
            <h5 className="title">{notification?.title}</h5>
            <br />
            <p>{notification?.description}</p>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default NotificationsUser;
